export default "__VITE_ASSET__069daef2__"